import { GlobalDialogComponent, Toaster } from '@nest/uikit-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import i18next from 'i18next';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import * as z from 'zod';
import { useWorkSessionSocket } from './features/wms-orchestrator/hooks/useWorkSessionSocket';
import { Router } from './router';

i18next.init({
	lng: 'cs'
});

z.config(z.locales.cs());

const queryClient = new QueryClient({
	defaultOptions: {
		mutations: {
			retry: false
		},
		queries: {
			retry: false
		}
	}
});

const AppContent = () => {
	useWorkSessionSocket();

	return (
		<>
			<GlobalDialogComponent />
			<Toaster position="bottom-center" richColors />
			<Router />
		</>
	);
};

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<NuqsAdapter>
				<AppContent />
			</NuqsAdapter>
		</QueryClientProvider>
	);
}

export default App;
